import React from "react";
import { Link } from "react-router-dom";
import DatafabriqLogo from "./DatafabriqLogo";

export interface ContentFooterLink {
  label: string;
  to: string;
}

interface ContentFooterProps {
  tagline?: string;
  resources: ContentFooterLink[];
  bottomLeft?: React.ReactNode;
  bottomRight?: React.ReactNode;
}

const ContentFooter: React.FC<ContentFooterProps> = ({
  tagline = "Operational software for your business. Auditable to the row.",
  resources,
  bottomLeft,
  bottomRight,
}) => {
  const year = new Date().getFullYear();

  return (
    <footer className="cs-footer">
      <div className="cs-footer-inner">
        <div className="cs-footer-brand">
          <DatafabriqLogo size="lg" />
          <p>{tagline}</p>
        </div>
        <div className="cs-footer-col">
          <h5>Resources</h5>
          {resources.map((item) => (
            <Link key={item.to} to={item.to}>{item.label}</Link>
          ))}
        </div>
        <div className="cs-footer-col">
          <h5>Contact</h5>
          <a href="mailto:support@datafabriq.co">support@datafabriq.co</a>
        </div>
      </div>
      <div className="cs-footer-bottom">
        <span>{bottomLeft ?? `© ${year} Data FabrIQ, Inc.`}</span>
        <span>{bottomRight ?? "Auditable to the row."}</span>
      </div>
    </footer>
  );
};

export default ContentFooter;
